<template>
	<div>
		<div class="grid grid-cols-2 gap-x-4 gap-y-4 items-end">
			<ui-select-group
				class="col-span-2"
				v-model="form.location.hub"
				field="location.hub"
				type="select"
				label="Market"
				:options="locationHubOptions"
				:form="form"
				:required="true"
				id="index-select-market"
			></ui-select-group>
			<!--
            <ui-select-group
                v-if="isMarketEmpty"
                id="index-select-grade"
                v-model="form.product.grade"
                field="product.grade"
                type="select"
                label="Article"
                :options="selectOptionsFirst"
                :form="form"
                :required="true"
                v-on:change="setProductType()"
            ></ui-select-group>
            -->
			<ui-select-group
				id="index-select-grade"
				v-model="form.product.grade"
				field="product.grade"
				type="select"
				label="Article"
				:options="
					productGradeOptions == null ? selectOptionsFirst : productGradeOptions
				"
				:form="form"
				:required="true"
				v-on:change="setProductType()"
			></ui-select-group>

			<ui-select-group
				id="index-select-year"
				v-model="form.product.harvest"
				field="product.harvest"
				type="select"
				label="Harvest Year"
				:options="harvestYearOptions"
				:form="form"
				:required="true"
			></ui-select-group>

			<ui-input-group
				v-model="form.qty.mt"
				field="qty.mt"
				label="Quantity"
				suffix="t"
				:form="form"
				:required="true"
			></ui-input-group>
			<div class="pb-2 mb-px">
				Toleranz:
				{{
					$cropOptions.getLocalizedLabel(
						form.qty.tolerance,
						$cropOptions.qtyToleranceOptions
					)
				}}
			</div>
			<div>
				<ui-select-group
					class="col-start-2 col-end-3"
					v-model="form.product.origin"
					field="product.origin"
					type="select"
					label="Origin"
					:options="$cropOptions.originOptions"
					:form="form"
					:required="true"
				>
				</ui-select-group>
			</div>
		</div>

		<!-- festpreis -->
		<ui-validation-message :form="form" field="price.type" />
		<div class="mt-4 space-y-2">
			<paper-edit-price-select :form="form" />
		</div>

		<paper-edit-price :form="form" :activeFutures="activeFutures" />

		<!-- date -->

		<div class="my-4">
			<ui-validation-message :form="form" field="date.type" />
			<div class="flex space-x-6">
				<ui-radio-group
					name="form.date.type"
					v-model="dateTypeChecker"
					radioValue="AT_HARVEST"
					:key="'AT_HARVEST-' + dateTypeChecker"
					label="At Harvest"
				></ui-radio-group>

				<ui-radio-group
					v-model="dateTypeChecker"
					name="form.date.type"
					radioValue="MONTH"
					:key="'MONTH-' + dateTypeChecker"
					label="Month"
				></ui-radio-group>

				<ui-radio-group
					v-if="dateTypeOptions.includes('MULTIPLE')"
					name="form.date.type"
					v-model="dateTypeChecker"
					radioValue="MULTIPLE"
					:key="'MULTIPLE-' + dateTypeChecker"
					label="Binding"
				></ui-radio-group>

				<ui-radio-group
					v-if="dateTypeOptions.includes('BASIS')"
					v-model="dateTypeChecker"
					name="form.date.type"
					radioValue="BASIS"
					:key="'BASIS-' + dateTypeChecker"
					label="Base"
				></ui-radio-group>
			</div>

			<!-- single month -->
			<div
				class="mt-4 grid grid-cols-2 gap-x-4 items-end"
				v-if="dateTypeChecker == 'MONTH'"
				:key="'DATETYPE-' + dateTypeChecker"
			>
				<ui-month-input-group
					v-model="form.date.month_to"
					field="date.month_to"
					label="Month"
					:form="form"
					:required="true"
				></ui-month-input-group>
			</div>

			<!-- two months -->
			<div
				class="mt-6 grid grid-cols-2 gap-x-4 items-end"
				v-else-if="['MULTIPLE', 'BASIS'].includes(dateTypeChecker)"
			>
				<ui-month-input-group
					v-model="form.date.month_from"
					field="date.month_from"
					label="Month From"
					:form="form"
					:required="true"
				></ui-month-input-group>

				<ui-month-input-group
					v-model="form.date.month_to"
					field="date.month_to"
					label="Month To"
					:form="form"
					:required="true"
				></ui-month-input-group>
			</div>
		</div>

		<!--div class="my-4 text-gray-500">
			{{ __("Please see the sample contracts for") }}
			{{ !selectedProduct && !selectedLocation ? __("Papermarket") : "" }}
			{{ selectedProduct }}
			{{ selectedLocation }}
		</div-->
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		offer: {
			type: Object,
			required: false,
		},
		filterOptions: {
			type: Object,
			required: false,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			locationHubOptions: this.$cropOptions.getPaperHubs(),
		};
	},
	watch: {
		form: {
			handler() {
				console.log("WATCHING form");
				if (this.form.product.grade) {
					console.log(
						this.currentHub.productGradeOptions[this.form.product.grade]
					);
					this.form.quality.paper_fixed =
						this.currentHub.productGradeOptions[this.form.product.grade];
				}
			},
			type: "deep",
		},
	},
	computed: {
		hubProductGrades() {
			if ([null, ""].includes(this.form.location.hub)) {
				return null;
			}
			let currentHub = this.currentHub,
				availableProductGradeOptions = Object.keys(
					currentHub.productGradeOptions
				);
			return availableProductGradeOptions;
		},
		productGradeOptions() {
			let availableProductGradeOptions = this.hubProductGrades;
			if (!availableProductGradeOptions) {
				return null;
			}
			return Object.values(this.$cropOptions.productGradeOptions)
				.flat()
				.filter((o) => availableProductGradeOptions.includes(o.id));
		},
		selectOptionsFirst() {
			let options = this.__("(Select market first)");
			return [
				{
					value: "Select market first",
					label: options,
				},
			];
		},
		currentHub() {
			let filteredHub = this.locationHubOptions.filter(
				(h) => h.id == this.form.location.hub
			);
			return filteredHub[0] ? filteredHub[0] : null;
		},
		dateTypeOptions() {
			return this.currentHub ? this.currentHub.dateTypeOptions : [];
		},
		isMarketEmpty() {
			if (this.offer.location.hub == null || this.offer.location.hub == "") {
				return true;
			}

			return false;
		},
		// @ DANIEL diesen punkt müssen wir noch mal klären?!
		selectedProduct: function () {
			//console.log(this.localOffer.product.grade);
			//console.log(this.localOffer.product);
			//return this.localOffer.product ? this.localOffer.product : null;

			//
			if (this.productGradeOptions != null && this.form.product != undefined) {
				let filteredProduct = this.productGradeOptions.filter(
					(h) => h.id == this.form.product.grade
				);
				return filteredProduct[0] ? this.__(filteredProduct[0].name) : "";
			}
		},
		/* @Hinnerk
		 ** why can't we use currentHub.name / how? ??? */
		selectedLocation: function () {
			let filteredHub = this.locationHubOptions.filter(
				(h) => h.id == this.form.location.hub
			);
			return filteredHub[0] ? this.__(filteredHub[0].name) : null;
		} /*
        selectedLocationFilter: function () {
            return this.filterOptions.locationHubs
                .filter(item => item.selected)
                .map(item => item.name_short)
                .join(', ')
        },*/,
		harvestYearOptions: function () {
			return this.$cropOptions.harvestYearOptions.map(function (i) {
				return { id: i, name: i };
			});
		},
		indexedPriceTypeIsDisabled() {
			return ["FABA", "PEA"].includes(this.form.product.type);
		},
		dateTypeChecker: {
			get() {
				return this.form.date.type;
			},
			set(newValue) {
				this.form.date.type = newValue;

				if (newValue == "AT_HARVEST") {
					this.form.date.month_from = null;
					this.form.date.month_to = null;
				} else if (newValue == "MONTH") {
					this.form.date.month_from = null;
				}
			},
		},
	},
	methods: {
		setProductType() {
			let grade = this.form.product.grade || "",
				type = grade.substr(0, grade.indexOf("_"));
			this.form.product.type = type == "" ? null : type;
			this.form.quality.paper_fixed =
				this.currentHub.productGradeOptions[this.form.product.grade] ?? null;
		},
	},
	created() {
		this.setProductType();
	},
};
</script>
